import React from 'react'
import sofa1 from '../assets/images/sofa1.jpeg';
import sofa2 from '../assets/images/sofa2.jpg';
import '../styles/gallary.css';
import { imageList } from '../data/data';
import { Helmet } from 'react-helmet-async';

type ImageListProp ={
  imgList:{}[]
}
console.log(imageList);

const Gallary = ({imgList}:ImageListProp) => {
  return (
    <>
     <Helmet>
          <title>Gallery - Explore Our Sofa Collection | Sofa bazaar in Ambikapur</title>
          <meta name='description' content='Explore our stunning sofa collection at sofa bazaar through our Gallery. Browse a wide variety of modern and classic designs to find the perfect sofa for your home. View our beautiful furniture now!'></meta>
          <link rel='canonical' href='https://www.sofabaazar.com/gallary' />
      </Helmet>
      <div className='container mb-3'>
        <div className='row'>
          <div className='col'>
            <div className="photo-gallery">
              <div className="container">
                <div className="intro">
                  <h1 className='display-6 p-5 text-center'>Explore Our Stunning Furniture Collection</h1>
                </div>
                <div className="row photos">
                  {
                    imgList.map((item:any)=>(

                      <div className="col-sm-4 col-xs-12 item" key={item.imageName}><a href={item.imageName} data-lightbox="photos" ><img className="img-fluid" src={item.imageName} /></a>
                        
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default Gallary
